// pages/PricingPage.jsx
import { useState } from "react"
import { Link } from "react-router-dom"

const FF = "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif"
const FM = FF

const C = {
  bg:         "#0e0e0e",
  bgNav:      "#111111",
  bgCard:     "#161616",
  bgChip:     "#1e1e1e",
  border:     "#242424",
  borderMid:  "#303030",
  text:       "#ffffff",
  textMuted:  "#888888",
  textDim:    "#444444",
  accent:     "#d3fe5b",
  accentText: "#0e0e0e",
}

const FEATURES = [
  { icon: "⚡", label: "Real-time job scanning",          note: "Yes, actually real-time" },
  { icon: "🧠", label: "AI-powered signal matching",      note: "The fancy ML kind" },
  { icon: "📍", label: "10 Indian cities covered",        note: "BLR to CCU, we got you" },
  { icon: "📋", label: "Application tracker (Command)",   note: "Kanban but make it dark" },
  { icon: "🔔", label: "Instant alerts",                  note: "Before your competitor applies" },
  { icon: "💼", label: "1,200+ companies tracked",        note: "The ones that matter" },
  { icon: "📊", label: "Salary intelligence",             note: "Know your worth, seriously" },
  { icon: "🚀", label: "Unlimited search signals",        note: "Go wild" },
  { icon: "🎯", label: "Supreme Score system",            note: "Gamified. You're welcome." },
  { icon: "😌", label: "No credit card required",         note: "We don't even have a billing page" },
  { icon: "🙅", label: "No upsell emails",                note: "Pinky promise" },
  { icon: "♾️", label: "Free forever",                    note: "Or until we get acquired" },
]

const FAQS = [
  {
    q: "Wait, it's actually free?",
    a: "Yes. No trial period. No 'free tier with 3 features locked'. No hidden charges. Just free. We know, it's weird.",
  },
  {
    q: "What's the catch?",
    a: "There isn't one. We built this because job hunting is already painful enough without paying $29/month to find out a role was posted 3 weeks ago.",
  },
  {
    q: "Will you charge me later?",
    a: "If we ever introduce paid plans, you'll keep everything you have. We're not LinkedIn.",
  },
  {
    q: "Do I need a credit card to sign up?",
    a: "No. We don't even have a payment form. Somewhere a VC is crying.",
  },
  {
    q: "How do you make money then?",
    a: "Great question. We'll figure that out later. Right now we're just trying to help people land jobs.",
  },
]

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false)
  return (
    <div
      style={{
        borderBottom: `1px solid ${C.border}`,
        cursor: "pointer",
      }}
      onClick={() => setOpen(o => !o)}
    >
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "18px 0",
        gap: 16,
      }}>
        <span style={{ fontSize: 15, fontWeight: 600, color: C.text, fontFamily: FF, lineHeight: 1.4 }}>{q}</span>
        <div style={{
          width: 24, height: 24, borderRadius: "50%",
          border: `1px solid ${C.borderMid}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          flexShrink: 0,
          transition: "border-color 0.15s, background 0.15s",
          background: open ? C.accent + "18" : "transparent",
          borderColor: open ? C.accent : C.borderMid,
        }}>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
            style={{ transition: "transform 0.2s", transform: open ? "rotate(45deg)" : "rotate(0deg)" }}>
            <path d="M5 1v8M1 5h8" stroke={open ? C.accent : C.textMuted} strokeWidth="1.6" strokeLinecap="round"/>
          </svg>
        </div>
      </div>
      {open && (
        <p style={{
          fontSize: 14, color: C.textMuted, fontFamily: FF,
          lineHeight: 1.7, paddingBottom: 18, margin: 0,
          animation: "faq-open 0.18s ease",
        }}>
          {a}
        </p>
      )}
    </div>
  )
}

export default function PricingPage() {
  return (
    <div style={{ minHeight: "100vh", background: C.bg, color: C.text, fontFamily: FF }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700;9..40,800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes float-badge {
          0%, 100% { transform: translateY(0) rotate(-2deg); }
          50%       { transform: translateY(-8px) rotate(2deg); }
        }
        @keyframes fade-up {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes faq-open {
          from { opacity: 0; transform: translateY(-4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulse-dot {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%       { opacity: 0.4; transform: scale(0.85); }
        }

        .nav-cta-btn {
          display: inline-flex; align-items: center;
          padding: 8px 20px;
          background: #d3fe5b;
          border-radius: 20px;
          font-size: 12px; font-weight: 700; font-family: ${FM};
          letter-spacing: 0.06em;
          color: #0e0e0e !important;
          text-decoration: none;
          transition: background 0.15s;
        }
        .nav-cta-btn:hover { background: #e8ff7a; }

        .feature-row:hover {
          background: #1a1a1a !important;
        }
        .feature-note {
          opacity: 1 !important;
          transform: translateX(0) !important;
        }
        .cta-btn {
          color: #0e0e0e !important;
          transition: background 0.15s, transform 0.15s !important;
        }
        .cta-btn:hover {
          background: #e8ff7a !important;
          transform: translateY(-1px);
        }

        ::-webkit-scrollbar { width: 4px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #2a2a2a; border-radius: 2px; }
      `}</style>

      {/* ── NAV ── */}
      <nav style={{ background: C.bgNav, borderBottom: `1px solid ${C.border}`, position: "sticky", top: 0, zIndex: 100, height: 52 }}>
        <div style={{ display: "flex", alignItems: "center", height: "100%", padding: "0 40px", maxWidth: 1100, margin: "0 auto" }}>
          <Link to="/" style={{ display: "flex", alignItems: "center", gap: 9, textDecoration: "none", marginRight: "auto" }}>
            <div style={{ width: 28, height: 28, borderRadius: "50%", background: C.accent, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: 10, fontWeight: 700, color: C.accentText, fontFamily: FM }}>JS</span>
            </div>
            <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: "0.08em", color: C.text, fontFamily: FM }}>RESOLUT</span>
          </Link>
          <Link to="/register" className="nav-cta-btn">
            GET STARTED
          </Link>
        </div>
      </nav>

      <div style={{ maxWidth: 780, margin: "0 auto", padding: "0 24px" }}>

        {/* ── HERO ── */}
        <div style={{
          textAlign: "center",
          padding: "80px 0 64px",
          animation: "fade-up 0.5s ease both",
        }}>
          {/* Floating price badge */}
          <div style={{
            display: "inline-flex", alignItems: "center", gap: 8,
            padding: "6px 18px",
            background: C.accent + "12",
            border: `1px solid ${C.accent}33`,
            borderRadius: 100,
            marginBottom: 32,
            animation: "float-badge 4s ease-in-out infinite",
          }}>
            <div style={{ width: 7, height: 7, borderRadius: "50%", background: C.accent, animation: "pulse-dot 2s ease infinite" }} />
            <span style={{ fontSize: 12, fontWeight: 700, color: C.accent, fontFamily: FM, letterSpacing: "0.1em" }}>
              PRICING — EST. 2026
            </span>
          </div>

          {/* Big price */}
          <div style={{ marginBottom: 24 }}>
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "center", gap: 4, marginBottom: 8 }}>
              <span style={{ fontSize: 22, fontWeight: 700, color: C.textMuted, marginTop: 14, fontFamily: FF }}>₹</span>
              <span style={{
                fontSize: 120, fontWeight: 800, lineHeight: 1,
                color: C.accent, fontFamily: FF,
                letterSpacing: "-0.05em",
              }}>0</span>
              <span style={{ fontSize: 22, fontWeight: 600, color: C.textMuted, marginTop: 14, fontFamily: FF }}>/mo</span>
            </div>
            <p style={{ fontSize: 13, color: C.textDim, fontFamily: FM, letterSpacing: "0.06em", fontWeight: 600 }}>
              ALSO ₹0/YR · ₹0/DECADE · ₹0/LIFETIME
            </p>
          </div>

          <h1 style={{
            fontSize: 38, fontWeight: 800, color: C.text,
            fontFamily: FF, letterSpacing: "-0.03em",
            lineHeight: 1.1, marginBottom: 16,
          }}>
            It's free.<br />
            <span style={{ color: C.accent }}>No strings attached.</span>
          </h1>

          <p style={{ fontSize: 16, color: C.textMuted, fontFamily: FF, lineHeight: 1.7, maxWidth: 520, margin: "0 auto 40px" }}>
            Job hunting is stressful enough. We're not going to charge you to find out about a role that expired 3 weeks ago. Resolut is free — for real, not "free trial" free.
          </p>

        </div>

        {/* ── FEATURES LIST ── */}
        <div style={{ marginBottom: 64, animation: "fade-up 0.5s 0.1s ease both" }}>
          {FEATURES.map((f, i) => (
            <div
              key={i}
              className="feature-row"
              style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                padding: "14px 0",
                borderBottom: `1px solid ${C.border}`,
                transition: "background 0.12s",
                cursor: "default",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ fontSize: 16, flexShrink: 0 }}>{f.icon}</span>
                <span style={{ fontSize: 14, fontWeight: 600, color: C.text, fontFamily: FF }}>{f.label}</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span
                  className="feature-note"
                  style={{
                    fontSize: 11, color: C.textDim, fontFamily: FM,
                    letterSpacing: "0.03em",
                    whiteSpace: "nowrap",
                  }}
                >
                  {f.note}
                </span>
                <div style={{ width: 18, height: 18, borderRadius: "50%", background: C.accent + "18", border: `1px solid ${C.accent}44`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg width="9" height="9" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6l3 3 5-5" stroke={C.accent} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ── FAQ ── */}
        <div style={{ marginBottom: 80, animation: "fade-up 0.5s 0.3s ease both" }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: C.textDim, fontFamily: FM, letterSpacing: "0.1em", marginBottom: 8 }}>
            COMMON QUESTIONS
          </p>
          <h2 style={{ fontSize: 26, fontWeight: 700, color: C.text, fontFamily: FF, letterSpacing: "-0.02em", marginBottom: 32 }}>
            Still suspicious? Fair.
          </h2>
          <div style={{ borderTop: `1px solid ${C.border}` }}>
            {FAQS.map((faq, i) => <FaqItem key={i} {...faq} />)}
          </div>
        </div>

        {/* ── FOOTER CTA ── */}
        <div style={{
          textAlign: "center", padding: "64px 0 80px",
          borderTop: `1px solid ${C.border}`,
          animation: "fade-up 0.5s 0.4s ease both",
        }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: C.textDim, fontFamily: FM, letterSpacing: "0.1em", marginBottom: 16 }}>
            READY WHEN YOU ARE
          </p>
          <h2 style={{ fontSize: 32, fontWeight: 800, color: C.text, fontFamily: FF, letterSpacing: "-0.02em", marginBottom: 12, lineHeight: 1.1 }}>
            Your next job is out there.<br />
            <span style={{ color: C.accent }}>Go get it. For free.</span>
          </h2>
          <p style={{ fontSize: 14, color: C.textMuted, fontFamily: FF, marginBottom: 32 }}>
            Seriously, stop reading. Just sign up.
          </p>
          <Link to="/register" className="cta-btn" style={{
            display: "inline-flex", alignItems: "center", gap: 8,
            padding: "14px 40px",
            background: C.accent, borderRadius: 100,
            fontSize: 14, fontWeight: 700, fontFamily: FM,
            letterSpacing: "0.07em", color: C.accentText,
            textDecoration: "none",
          }}>
            I'M IN — LET'S GO
            <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
              <path d="M2 2h10v10M2 12L12 2" stroke={C.accentText} strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </Link>
        </div>

      </div>
    </div>
  )
}